/**
 * Created by Jonas Wålekvist on 2019-07-01.
 */
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Timeline, TimelineMax, TimelineLite,TweenLite,TweenMax,Ease, Linear, Power2,Power1, Power0, Power3, Power4,Expo, Elastic} from "gsap";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WixxGameConfig} from "../../WixxGameConfig";


export class WixxWinCountUp extends BitmapWinCountUp {

    constructor() {
        super({
            font : {
                name : "NumbersOpenSans800",
                size : 60
            },
            tint : 0xffffff
        });
        StageManager.getLayer(WixxGameConfig.instance.LAYERS.WIN_FIELD.name).addChild(this);
    }


    protected initAnimations():void {
        super.initAnimations();
        this._countUp.visible = true;
        this._countUpContainer.position.set(640, 550);
        this._countUpContainer.alpha = 0;
        this._countUpContainer.visible = false;
    }

    getCountUpAnimation(from:number, to:number, duration:number, ...params:any[]):gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._countUpContainer.visible = true;
        });

        if (from === 0){
            tl.add(() => {
                this._countUpContainer.scale.set(0,0);
            });
        }


        const scaleUpAnimation = new TimelineLite();
        scaleUpAnimation.add(new TweenLite(this._countUpContainer.scale, 0.1, {x:0.7,y:0.7, ease:Linear.easeNone}));
        scaleUpAnimation.add(new TweenLite(this._countUpContainer.scale, duration-0.1, {x:0.9,y:0.9, ease:Linear.easeNone}));
        scaleUpAnimation.add(new TweenLite(this._countUpContainer.scale, 0.1, {x:1,y:1, ease:Linear.easeNone}));

        tl.add([
            new TweenLite(this._countUpContainer,0.1,{alpha:1}),
            scaleUpAnimation,
            this._countUp.getCountUpAnimation(from, to, {duration : duration, ease:Linear.easeNone})
        ]);

        return tl;
    }


    protected getAbortAnimation(endValue:number, ...params:any[]):gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax {
        return this.getEndingAnimation(endValue, params);
    }


    getEndingAnimation(endValue:number, ...params:any[]):gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._countUpContainer.alpha = 1;
            this._countUpContainer.visible = true;
        });

        //Set to final value
        tl.add([
            new TweenLite(this._countUpContainer.scale, 0.0001, {x:1,y:1, ease:Linear.easeNone}),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0})
        ]);

        //fade out
        tl.add([
            new TweenLite(this._countUpContainer.scale, 1, {x:0,y:0, ease:Power1.easeIn}),
            new TweenLite(this._countUpContainer,0.5,{alpha:0})
        ],"+=0.8");

        return tl;
    }
}